import { type ComponentProps, useBlockNoteEditor } from "@blocknote/react";
import classNames from "classnames";
import {
  Description,
  Icon,
  bgStyles,
  borderStyles,
  flexStyles,
  heightStyles,
  iconStyles,
  paddingStyles,
  textStyles,
} from "ui";

type Props = ComponentProps["Generic"]["Menu"]["Item"];

export function Item({ children, checked, className, icon, onClick, subTrigger }: Props) {
  const editor = useBlockNoteEditor();

  const localOnClick = () => {
    if (!subTrigger) {
      onClick?.();
      editor?.sideMenu.unfreezeMenu();
    }
  };

  return (
    <button
      type="button"
      className={classNames(
        flexStyles.horiz025,
        heightStyles.height125,
        flexStyles.alignCenter,
        iconStyles.neutral600,
        bgStyles.none,
        bgStyles.hoverNeutral200,
        borderStyles.radius025,
        borderStyles.none,
        paddingStyles.p025,
        className,
      )}
      onClick={localOnClick}
    >
      {icon}
      <Description className={classNames(textStyles.left, flexStyles.grow)}>{children}</Description>
      {checked && <Icon iconType="Check" />}
    </button>
  );
}
